import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-u",
  "use": "arrow-u-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-u\"><defs><style>#arrow-u .cls-1{fill:none}</style></defs><title>资源 79</title><g id=\"arrow-u_图层_2\" data-name=\"图层 2\"><g id=\"arrow-u_图层_1-2\" data-name=\"图层 1\"><path id=\"arrow-u_Rectangle_36_Copy_3\" data-name=\"Rectangle 36 Copy 3\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"arrow-u_up\"><path id=\"arrow-u_Shape\" d=\"M21 17a1.08 1.08 0 0 0-.22-.65l-8-9.93a1 1 0 0 0-1.44-.16 1.21 1.21 0 0 0-.16.16l-7.95 9.86a1 1 0 0 0 .16 1.44 1 1 0 0 0 1.44-.16L12 8.66l7.18 9A1 1 0 0 0 21 17z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-u.svg
// module id = 5EjI
// module chunks = 6